/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { LoaderLayout } from "components/atoms/loader/LoaderLayout";
import { TheaterModeProvider } from "contexts/TheaterModeContext";

import StreamingV2 from "./StreamingV2";
import { useEventIdFromUrl } from "./enableNewPlayer";
import { useFeatureFlagFromFirestore } from "./useFeatureFlagFromFirestore";
import { useGetTHEOPlayerRuntime } from "./useGetTHEOPlayerRuntime";
import { useGetMainVideoIdResolver } from "./videojsComponent/multiAngle/useVideoGroupsSet";

import type { EventInfo } from "../../utility";
import type { EventVideo, THEOSetting } from "@spwn/types/firebase/firestore";
import type { Cookie } from "@spwn/types/functions";

export type StreamingSwitcherProps = {
  url: string;
  event: EventInfo;
  hasTicket: boolean;
  cookies: {
    [videoId: string]: {
      LL?: Cookie;
      default: Cookie;
    };
  };
  cookiesList?: {
    [videoId: string]: {
      [videoId: string]: {
        LL?: Cookie;
        default: Cookie;
      };
    }[];
  } | null;
  vid: string;
  vodSetting: THEOSetting;
  liveSetting: THEOSetting;
  eventVideoMap: { [videoId: string]: EventVideo };
  getStreamingKey?: () => Promise<void>;
  isPollingEnabled?: boolean;
  isDarkModeEnabled: boolean;
};

export const StreamingSwitcher = (props: StreamingSwitcherProps) => {
  const eventId = useEventIdFromUrl();
  const isLLHLSEnabled = useFeatureFlagFromFirestore("llhls", eventId, {
    enable: "useLLHLS",
    disable: "disableLLHLS",
  });
  const isSignedUrlEnabled = useFeatureFlagFromFirestore("signedUrl", eventId);
  const isMMSForVODEnabled = useFeatureFlagFromFirestore("MMSForVOD", eventId, {
    enable: "MMSForVOD",
  });
  const isPollingEnabled = useFeatureFlagFromFirestore("polling", eventId, {
    enable: "polling",
    disable: "noPolling",
  });
  const { event } = props;

  const getMainVideoId = useGetMainVideoIdResolver();
  const theoPlayerRuntime = useGetTHEOPlayerRuntime();

  if (
    getMainVideoId === undefined ||
    isLLHLSEnabled === undefined ||
    isSignedUrlEnabled === undefined ||
    isMMSForVODEnabled === undefined ||
    isPollingEnabled === undefined ||
    theoPlayerRuntime === null
  ) {
    return <LoaderLayout />;
  }

  return (
    <TheaterModeProvider
      isHiddenStreamingComment={event.isHiddenStreamingComment}
    >
      <StreamingV2
        {...props}
        theoPlayerRuntime={theoPlayerRuntime}
        getMainVideoId={getMainVideoId}
        isLLHLSEnabled={isLLHLSEnabled}
        isSignedUrlEnabled={isSignedUrlEnabled}
        isMMSForVODEnabled={isMMSForVODEnabled}
        isPollingEnabled={isPollingEnabled}
      />
    </TheaterModeProvider>
  );
};
